export const LIST_ITEM_HEIGHT = 40;
export const SPACING_ICON_TEXT = 8;
export const PADDING_LIST_ITEM_LEFT_RIGHT = 12;
export const BORDER_RADIUS = 6;
export const INPUT_HEIGHT = 40;
export const NAVIGATION_ITEM_HEIGHT = 48;
